module.exports = __webpack_public_path__ + "static/flex-logo-small-e07d3caccc89e6667ad939106bee2cd7.png";